// @flow

import Game from '@/lib/game';

export default class {
  static isSatisfied(game: Game): boolean {
    const { mapleAdultTreesCount } = game.stats;
    return mapleAdultTreesCount >= 5 && game.virtualTime.season === 'autumn';
  }

  static makeAchievement() {
    return {
      uid: 'maple_forest',
      title: '紅葉の季節',
      body: '楓の木が育ち、紅葉を観に多くの観光客が訪れています。',
    };
  }
}



// WEBPACK FOOTER //
// ./src/lib/achievement_conditions/maple_forest.js